<template>
  <div class="intallment-option-list">
    <InstallmentOptionBoxV2
      @click="() => onClick(i)"
      v-for="(intOpt, i) in installmentOptions"
      :loadingValues="loadingValues"
      :key="i"
      :active="i === indexSelected"
      :installmentNumber="intOpt.installments"
      :installmentValue="intOpt.value"
      :interest="intOpt.interest"
      :totalValue="intOpt.total"
    />
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';
import InstallmentOptionBoxV2 from '@/components/common/InstallmentOptionBoxV2.vue';

export default {
  name: 'installment-option-list-v2',
  mixins: [StringMixin],
  components: { InstallmentOptionBoxV2 },
  props: {
    indexSelected: {
      type: Number,
    },
    installmentOptions: {
      type: Array,
      required: true,
    },
    loadingValues: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    installmentChange(index) {
      this.$emit('installmentChange', index);
    },
    onClick(index) {
      this.installmentChange(index);
    },
  },
  mounted() {
    if (typeof this.indexSelected === 'number' && this.indexSelected >= 0) {
      this.installmentChange(this.indexSelected);
    }
  },
};
</script>

<style lang="scss" scoped>
  .intallment-option-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
</style>
